export default __webpack_public_path__ + "static/media/banner-img.a9fc2208.png";